import { logout } from '../lib/api';
import type { ModelAlias } from '../lib/types';

interface Props {
  account: string | null;
  model: ModelAlias;
  onClear: () => void;
  onLogout: () => void;
  onOpenCookies?: () => void;
  onOpenHealth?: () => void;
}

export function Header({ account, model, onClear, onLogout, onOpenCookies, onOpenHealth }: Props) {
  async function handleLogout(): Promise<void> {
    try {
      await logout();
    } catch {
      /* ignore */
    }
    onLogout();
  }
  return (
    <header className="border-b border-gray-800 px-4 py-3 flex items-center justify-between sticky top-0 bg-gray-950 z-10">
      <div className="flex items-center gap-2 min-w-0">
        <h1 className="font-semibold tracking-tight truncate">claude-api</h1>
        <span className="text-xs text-gray-500 px-2 py-0.5 rounded-full bg-gray-900 border border-gray-800">
          {model}
        </span>
        {account && (
          <span className="text-xs text-gray-500 px-2 py-0.5 rounded-full bg-gray-900 border border-gray-800">
            {account}
          </span>
        )}
      </div>
      <div className="flex gap-1 text-sm">
        <button
          type="button"
          onClick={onClear}
          className="px-3 py-1 text-gray-400 hover:text-gray-100 hover:bg-gray-800 rounded transition"
        >
          новый
        </button>
        {onOpenHealth && (
          <button
            type="button"
            onClick={onOpenHealth}
            className="px-3 py-1 text-emerald-400 hover:text-emerald-300 hover:bg-gray-800 rounded transition"
            title="health"
          >
            Health
          </button>
        )}
        {onOpenCookies && (
          <button
            type="button"
            onClick={onOpenCookies}
            className="px-3 py-1 text-gray-400 hover:text-gray-100 hover:bg-gray-800 rounded transition"
            title="cookies"
          >
            🍪
          </button>
        )}
        <button
          type="button"
          onClick={handleLogout}
          className="px-3 py-1 text-gray-400 hover:text-gray-100 hover:bg-gray-800 rounded transition"
        >
          выход
        </button>
      </div>
    </header>
  );
}
